"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.orderby"));

var _lodash2 = _interopRequireDefault(require("lodash.isequal"));

var _lodash3 = _interopRequireDefault(require("lodash.debounce"));

var _lodash4 = _interopRequireDefault(require("lodash.memoize"));

var _lodash5 = _interopRequireDefault(require("lodash.omit"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _Timeline = _interopRequireDefault(require("./Timeline"));

var _utils = require("../utils");

var _utils2 = require("../../../utils");

var _elMeasurements = require("../../../constants/elMeasurements");

var _bulkAddTimelineEvent = _interopRequireDefault(require("../../../../../../../constants/bulkAddTimelineEvent"));

var _getAssetMetaDataField = _interopRequireDefault(require("../../../../../utils/getAssetMetaDataField"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var BOTTOM_LAYER_ID = 'bottomClips';
var TOP_LAYER_ID = 'topClips';

function getClipSource(clipId, bottomClips) {
  return bottomClips.some(function (clip) {
    return clip.clipId === clipId;
  }) ? BOTTOM_LAYER_ID : TOP_LAYER_ID;
}

function removeClipFromClips(clips, clipIndex) {
  var arrayWithoutClip = _toConsumableArray(clips);

  arrayWithoutClip.splice(clipIndex, 1);
  return arrayWithoutClip;
}

function getDestinationClips(destinationClipsArray, newClip) {
  return !destinationClipsArray.length ? [newClip] : (0, _lodash.default)((0, _utils.addNewClipToClips)(newClip, destinationClipsArray), 'startTime');
}

var TimelineRoot = /*#__PURE__*/function (_Component) {
  _inherits(TimelineRoot, _Component);

  var _super = _createSuper(TimelineRoot);

  function TimelineRoot(_ref) {
    var _this;

    var _ref$initialClips = _ref.initialClips,
        initialClips = _ref$initialClips === void 0 ? [] : _ref$initialClips;

    _classCallCheck(this, TimelineRoot);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleDeleteClip", (0, _lodash4.default)(function (clipId) {
      return function () {
        _this.updateClips(clipId, function (_ref2) {
          var clips = _ref2.clips,
              clipIndex = _ref2.clipIndex;
          return removeClipFromClips(clips, clipIndex);
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleSnapClip", (0, _lodash4.default)(function (clipId) {
      return function () {
        _this.updateClips(clipId, function (_ref3) {
          var clips = _ref3.clips,
              clipIndex = _ref3.clipIndex,
              previousClip = _ref3.previousClip;

          if (!previousClip && clips[clipIndex].startTime === 0) {
            return null;
          }

          clips.splice(clipIndex, 1, _objectSpread(_objectSpread({}, clips[clipIndex]), {}, {
            startTime: previousClip ? previousClip.startTime + previousClip.duration : 0
          }));
          return clips;
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleSnapMultipleClips", (0, _lodash4.default)(function (clipId) {
      return function () {
        _this.updateClips(clipId, function (_ref4) {
          var clips = _ref4.clips,
              clipIndex = _ref4.clipIndex;
          return clips.reduce(function (snappedClips, clip, index) {
            if (index < clipIndex) {
              return [].concat(_toConsumableArray(snappedClips), [clip]);
            }

            var previousClip = snappedClips[snappedClips.length - 1];

            if (!previousClip) {
              return [].concat(_toConsumableArray(snappedClips), [_objectSpread(_objectSpread({}, clip), {}, {
                startTime: 0
              })]);
            }

            return [].concat(_toConsumableArray(snappedClips), [_objectSpread(_objectSpread({}, clip), {}, {
              startTime: previousClip.startTime + previousClip.duration
            })]);
          }, []);
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleClipResize", (0, _lodash3.default)(function (clipId, time, _ref5) {
      var isStartTime = _ref5.isStartTime;

      _this.updateClips(clipId, function (_ref6) {
        var clips = _ref6.clips,
            clipIndex = _ref6.clipIndex;
        var clip = clips[clipIndex];

        if (!clip) {
          return null;
        }

        if (!isStartTime) {
          var _newDuration = time - clip.startTime;

          var duration = _newDuration > clip.originalDuration && !clip.isImage ? clip.originalDuration : _newDuration;
          clips.splice(clipIndex, 1, _objectSpread(_objectSpread({}, clip), {}, {
            duration: duration
          }));
          return clips;
        }

        var clipStartTime = time - clip.startTime;
        var newClipStartTime = clipStartTime + clip.clipStartTime;
        var newDuration = clip.duration - clipStartTime;
        clips.splice(clipIndex, 1, _objectSpread(_objectSpread({}, clip), {}, {
          duration: newDuration,
          startTime: time,
          clipStartTime: newClipStartTime
        }));
        return clips;
      });
    }, 50));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      document.addEventListener(_bulkAddTimelineEvent.default, _this.onAddBulkClipsToTimeline);
    });

    _defineProperty(_assertThisInitialized(_this), "updateVideoClipsFromState", function () {
      var _this$state = _this.state,
          bottomClips = _this$state.bottomClips,
          topClips = _this$state.topClips;
      var onUpdateClipLayers = _this.props.onUpdateClipLayers;
      onUpdateClipLayers(bottomClips, topClips);
    });

    _defineProperty(_assertThisInitialized(_this), "buildDraggedClip", function (_ref7) {
      var existingClip = _ref7.existingClip,
          time = _ref7.time,
          asset = _ref7.asset,
          layerIndex = _ref7.layerIndex;

      if (!existingClip) {
        var duration = asset ? (0, _getAssetMetaDataField.default)('duration', asset, {
          fallback: 2
        }) : 0;
        return {
          assetId: asset ? asset.assetId : '',
          duration: duration,
          originalDuration: duration,
          startTime: time,
          clipId: "clip-".concat((0, _v.default)()),
          clipStartTime: 0,
          isEmpty: false,
          isImage: asset ? (0, _getAssetMetaDataField.default)('type', asset).includes('image') : false,
          layerIndex: layerIndex
        };
      }

      return _objectSpread(_objectSpread({}, existingClip), {}, {
        startTime: time,
        layerIndex: layerIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateClipsFromAssets", function (assets, insertStartTime, layerIndex, clipDestination) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          state = _assertThisInitialize.state;

      var destinationClips = state[clipDestination];
      var newClips = assets.reduce(function (_ref8, selectedAsset) {
        var totalTime = _ref8.totalTime,
            clips = _ref8.clips;

        var clip = _this.buildDraggedClip({
          time: totalTime,
          asset: selectedAsset,
          layerIndex: layerIndex
        });

        return {
          totalTime: totalTime + clip.duration,
          clips: [].concat(_toConsumableArray(clips), [clip])
        };
      }, {
        totalTime: insertStartTime,
        clips: []
      });
      var newDestinationClips = newClips.clips.reduce(function (finalClips, clip) {
        return getDestinationClips(finalClips, clip);
      }, destinationClips);

      _this.setState(_defineProperty({}, clipDestination, newDestinationClips), _this.updateVideoClipsFromState);
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragClip", function (_ref9, _ref10, droppableId) {
      var asset = _ref9.asset,
          clipId = _ref9.clipId;
      var xPos = _ref10.xPos;
      var selectedAssets = _this.props.selectedDrawerAssets;
      var timelineDrawerContent = document.querySelector('.timeline .drawer__content');

      if (!timelineDrawerContent) {
        return;
      }

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          state = _assertThisInitialize2.state,
          bottomClips = _assertThisInitialize2.state.bottomClips,
          timelineZoomSeconds = _assertThisInitialize2.props.timelineZoomSeconds;

      var clipDestination = droppableId === 'timeline-layer-lower' ? BOTTOM_LAYER_ID : TOP_LAYER_ID;
      var layerIndex = clipDestination === BOTTOM_LAYER_ID ? 1 : 0;
      var xPosWithScroll = xPos + timelineDrawerContent.scrollLeft - _elMeasurements.TIMELINE_LEFT_OFFSET;
      var startTime = (0, _utils2.normaliseTime)(xPosWithScroll / _elMeasurements.TIMELINE_LABEL_WIDTH * timelineZoomSeconds);

      if (!clipId && asset) {
        var draggedASelectedAsset = selectedAssets.some(function (selectedAsset) {
          return selectedAsset.assetId === asset.assetId;
        });
        var assetsToAdd = draggedASelectedAsset ? selectedAssets : [asset];
        return void _this.updateClipsFromAssets(assetsToAdd, startTime, layerIndex, clipDestination);
      }

      if (!clipId) {
        return;
      }

      var clipSource = getClipSource(clipId, bottomClips);

      var newSourceClips = _toConsumableArray(state[clipSource]);

      var clipIndex = newSourceClips.findIndex(function (clip) {
        return clip.clipId === clipId;
      });

      var newClip = _this.buildDraggedClip({
        existingClip: newSourceClips[clipIndex],
        time: startTime,
        asset: asset,
        layerIndex: layerIndex
      });

      newSourceClips.splice(clipIndex, 1);
      var sourceIsDestination = clipSource === clipDestination;
      var destinationClips = sourceIsDestination ? newSourceClips : state[clipDestination];

      _this.setState(_objectSpread(_defineProperty({}, clipDestination, getDestinationClips(destinationClips, newClip)), sourceIsDestination ? {} : _defineProperty({}, clipSource, newSourceClips)), _this.updateVideoClipsFromState);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddBulkClipsToTimeline", function () {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          state = _assertThisInitialize3.state;

      var selectedAssets = _this.props.selectedDrawerAssets;
      var destinationClips = state[BOTTOM_LAYER_ID];
      var lastClip = destinationClips[destinationClips.length - 1];
      var startTime = lastClip ? lastClip.startTime + lastClip.duration : 0;

      _this.updateClipsFromAssets(selectedAssets, startTime, 1, BOTTOM_LAYER_ID);
    });

    var _topClips = initialClips.filter(function (clip) {
      return clip.layerIndex === 0;
    });

    var _bottomClips = initialClips.filter(function (clip) {
      return clip.layerIndex === 1;
    });

    _this.state = {
      topClips: _topClips,
      bottomClips: _bottomClips
    };
    return _this;
  }

  _createClass(TimelineRoot, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener(_bulkAddTimelineEvent.default, this.onAddBulkClipsToTimeline);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$state2 = this.state,
          topClips = _this$state2.topClips,
          bottomClips = _this$state2.bottomClips;
      return !(0, _lodash2.default)(nextState.topClips, topClips) || !(0, _lodash2.default)(nextState.bottomClips, bottomClips) || !(0, _lodash2.default)((0, _lodash5.default)(nextProps, 'initialClips'), (0, _lodash5.default)(this.props, 'initialClips'));
    }
  }, {
    key: "updateClips",
    value: function updateClips(clipId, getNewClips) {
      var state = this.state;
      var bottomClips = state.bottomClips;
      var clipSource = getClipSource(clipId, bottomClips);
      var clips = state[clipSource];
      var clipIndex = clips.findIndex(function (clip) {
        return clip.clipId === clipId;
      });
      var previousClip = clips[clipIndex - 1];
      var newClips = getNewClips({
        clips: _toConsumableArray(clips),
        clipIndex: clipIndex,
        previousClip: previousClip
      });

      if (!newClips) {
        return;
      }

      this.setState(_defineProperty({}, clipSource, newClips), this.updateVideoClipsFromState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          topClips = _this$state3.topClips,
          bottomClips = _this$state3.bottomClips;
      var _this$props = this.props,
          onOverrideCurrentTime = _this$props.onOverrideCurrentTime,
          timelineZoomSeconds = _this$props.timelineZoomSeconds,
          canUpdateVideo = _this$props.canUpdateVideo;
      return /*#__PURE__*/_react.default.createElement(_Timeline.default, {
        topClips: topClips,
        bottomClips: bottomClips,
        onClipDrop: this.handleDragClip,
        handleClipResize: this.handleClipResize,
        onDeleteClip: this.handleDeleteClip,
        onSnapClip: this.handleSnapClip,
        onSnapMultipleClips: this.handleSnapMultipleClips,
        onOverrideCurrentTime: onOverrideCurrentTime,
        timelineZoomSeconds: timelineZoomSeconds,
        canUpdateVideo: canUpdateVideo
      });
    }
  }]);

  return TimelineRoot;
}(_react.Component);

exports.default = TimelineRoot;